import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setNeoAuthenticated } from "../../redux/actions/UserActions";
import { appConfig } from "App";

const LogoutNeo = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Clear Neo authentication state
    dispatch(setNeoAuthenticated(false));
    
    // Clear neo token from localStorage
    localStorage.removeItem('neo_id_token');
    // localStorage.removeItem('cuesheet_id');
    // localStorage.removeItem('workspaceid');
    
    // Redirect to neo-login
    window.location.href = `${appConfig.CENTRAL_API}/neo-login`;
  }, [dispatch]);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h3>Logging out...</h3>
      <p>Please wait while we log you out.</p>
    </div>
  );
};

export default LogoutNeo;
